<script>
import {computed} from 'vue';
import {useStore} from '@/helpers/store-effect';
import {TreeManager} from '@/services/tree-manager';
import {NodeMixin} from '@/helpers/node-mixin';
import {useFocus} from "@/helpers/focus-effect";

export default {
  name: 'NewNode',
  template: '#new-node-template',
  mixins: [NodeMixin],
  setup(props) {
    const store = useStore();
    const {setFocus} = useFocus();
    const close = () => {
      store.expandedNode = '';
    };
    const toggle = () => store.expandedNode = props.node.uid;
    const expanded = computed(() => store.expandedNode === props.node.uid);
    const add = (nodeType) => {
      const newNode = TreeManager.addNode(store.workflow, props.node, nodeType);
      setFocus(newNode)
      close();
    };

    return {
      toggle,
      expanded,
      add,
    };
  },
};
</script>
